
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speaker/[slug]/booking-request",
      function () {
        return require("private-next-pages/speaker/[slug]/booking-request.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speaker/[slug]/booking-request"])
      });
    }
  